import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
// import history from './history'
import PrivateRoute from "./privateRoute";
import Layout from "../layout";
import { Auth, User, Profile, Password } from "../pages/auth";
import Dashboard from "../pages/dashboard";
import { Dictionary, DictionaryItem } from "../pages/dictionary";
import { Kaya, Member, KayaMember, MemberDead } from "../pages/kaya";
import { Region, District, Shehia, Zone, Ward, Street } from "../pages/boundary";
import { Building, BuildingKaya } from "../pages/building";
import Map from "../pages/map";
import Error from "../pages/error";
import UserGroup from "../pages/auth/UserGroup";
import Leader from "../pages/boundary/leader";
import Island from "../pages/boundary/island";
import { EditDictionary } from "../components/dictionary/dictionary/editDictionary";
import { EditDictionaryItem } from "../components/dictionary/dictionaryitem/editDictionaryItem";
import { ReportData1, ReportData2, ReportData3, SettlementOverviewPage, MemberListLive, MemberListDead, StatisticsDashboardPage, VitalReportPage } from "../pages/report";

export default function Routers() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Auth />} />
        <Route
          exact
          path="/map"
          element={
            <PrivateRoute>
              <Map />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Error />} />
        <Route element={<Layout />}>
          <Route
            exact
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/dictionary"
            element={
              <PrivateRoute>
                <Dictionary />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/edit-dictionary/:id"
            element={
              <PrivateRoute>
                <EditDictionary />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/dictionaryitem"
            element={
              <PrivateRoute>
                <DictionaryItem />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/edit-dictionary-item/:id"
            element={
              <PrivateRoute>
                <EditDictionaryItem />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/kaya"
            element={
              <PrivateRoute>
                <Kaya />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/member"
            element={
              <PrivateRoute>
                <Member />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/memberdead"
            element={
              <PrivateRoute>
                <MemberDead />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/kayamember"
            element={
              <PrivateRoute>
                <KayaMember />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/island"
            element={
              <PrivateRoute>
                <Island />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/region"
            element={
              <PrivateRoute>
                <Region />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/district"
            element={
              <PrivateRoute>
                <District />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/shehia"
            element={
              <PrivateRoute>
                <Shehia />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/zone"
            element={
              <PrivateRoute>
                <Zone />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/ward"
            element={
              <PrivateRoute>
                <Ward />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/street"
            element={
              <PrivateRoute>
                <Street />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/leader"
            element={
              <PrivateRoute>
                <Leader />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/building"
            element={
              <PrivateRoute>
                <Building />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/buildingkaya"
            element={
              <PrivateRoute>
                <BuildingKaya />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/user"
            element={
              <PrivateRoute>
                <User />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/password"
            element={
              <PrivateRoute>
                <Password />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/role"
            element={
              <PrivateRoute>
                <UserGroup />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/statistics-dashboard"
            element={
              <PrivateRoute>
                <StatisticsDashboardPage />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/vital-report"
            element={
              <PrivateRoute>
                <VitalReportPage />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/report1"
            element={
              <PrivateRoute>
                <ReportData1 />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/report2"
            element={
              <PrivateRoute>
                <ReportData2 />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/report3"
            element={
              <PrivateRoute>
                <ReportData3 />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/settlement-overview"
            element={
              <PrivateRoute>
                <SettlementOverviewPage />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/report-members-live"
            element={
              <PrivateRoute>
                <MemberListLive />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/report-members-dead"
            element={
              <PrivateRoute>
                <MemberListDead />
              </PrivateRoute>
            }
          />
        </Route>
      </Routes>
    </Router>
  );
}
